<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <v-card
        max-width="200px"
        :class="selected_supply_only_plant?'selected':'unselected'"
        @click="selected_supply_only_plant = !selected_supply_only_plant"
        style="height:100%;"
      >
        <div
            style="position: absolute; top: -5px; right: 0;"
            v-on:click.stop.prevent
        >
          <v-checkbox
            v-model="selected_supply_only_plant"
            hide-details
          ></v-checkbox>
        </div>
        <div style="display:flex; width:100%; justify-content:center;">
          <img alt="image of oxygen plant" src="@/assets/plant.png" style="height:120px;"/>
        </div>

        <v-card-title style="text-align:center; min-height: 4em; padding-top: 0; padding-bottom: 0;">{{$t('Oxygen Plant (PSA)')}}</v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card
        max-width="200px"
        :class="selected_supply_only_concentrator?'selected':'unselected'"
        @click="selected_supply_only_concentrator = !selected_supply_only_concentrator"
        style="height:100%;"
      >
        <div
            style="position: absolute; top: -5px; right: 0;"
            v-on:click.stop.prevent
        >
          <v-checkbox
            v-model="selected_supply_only_concentrator"
            hide-details
          ></v-checkbox>
        </div>
        <div style="display:flex; width:100%; justify-content:center;">
          <img alt="image of portable oxygen concentrator" src="@/assets/concentrator.png" style="height:120px;"/>
        </div>

        <v-card-title style="text-align:center; min-height: 4em; padding-top: 0; padding-bottom: 0;">
          {{ $t('Portable Oxygen Concentrator (PSA)') }}
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card
        max-width="200px"
        :class="selected_supply_only_liquid?'selected':'unselected'"
        @click="selected_supply_only_liquid = !selected_supply_only_liquid"
        style="height:100%;"
      >
        <div
            style="position: absolute; top: -5px; right: 0;"
            v-on:click.stop.prevent
        >
          <v-checkbox
            v-model="selected_supply_only_liquid"
            hide-details
          ></v-checkbox>
        </div>
        <div style="display:flex; width:100%; justify-content:center;">
          <img alt="image of liquid oxygen vie" src="@/assets/liquid.png" style="height:120px;"/>
        </div>

        <v-card-title style="text-align:center; min-height: 4em; padding-top: 0; padding-bottom: 0;">
          {{ $t('Liquid Oxygen (VIE)') }}
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card
        max-width="200px"
        :class="selected_supply_only_cylinder?'selected':'unselected'"
        @click="selected_supply_only_cylinder = !selected_supply_only_cylinder"
        style="height:100%;"
      >
        <div
            style="position: absolute; top: -5px; right: 0;"
            v-on:click.stop.prevent
        >
          <v-checkbox
            v-model="selected_supply_only_cylinder"
            hide-details
          ></v-checkbox>
        </div>
        <div style="display:flex; width:100%; justify-content:center;">
          <img alt="image of oxygen cylinders" src="@/assets/cylinder.png" style="height:120px;"/>
        </div>

        <v-card-title style="text-align:center; min-height: 4em; padding-top: 0; padding-bottom: 0;">
          {{ $t('Oxygen Cylinders') }}
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {

  data: () => ({  }),
  
  computed: {
    ...mapFields([
      'selected_supply_only_plant',
      'selected_supply_only_concentrator',
      'selected_supply_only_liquid',
      'selected_supply_only_cylinder',
      'showoverlay_cylinder',
      'sources',
      'source',
      'cylinder_types',
      'cylinder_type',
      'supply_types',
      'supply_type_plant',
      'supply_type_liquid',
      'supply_type_concentrator',
    ])
  },

  methods: { },

}
</script>

<style scoped>
  .v-card.selected {
    border-color: blue;
    border-width: 3px;
    border-style: solid;
    opacity: 1;
    margin: 5px;
  }
  .v-card.unselected:hover {
    opacity: 1;
  }
  .v-card.unselected {
    border-color: transparent;
    border-width: 3px;
    border-style: solid;
    opacity: 0.6;
    margin: 5px;
  }

  .v-card__text {
    padding-bottom: 0;
  }
</style>
